import React, { useState, useEffect, useContext } from 'react';
import { useQuery } from "react-query";
import { Select, Spin } from 'antd';
import Fuse from 'fuse.js';

import { AuthContext } from '../../containers/App';
import * as COM from '.';

export const DatasetSelect2 = (props) => {
  // const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  // const [dataOrig, setDataOrig] = useState([]);
  const auth = useContext(AuthContext);

  const { isLoading: loading, error, data: dataOrig, isFetching, refetch } = useQuery(['dataset', props.dataset], async () => {    
    let data = await COM.fetchData({
      connector: props.connector,
      dataset: props.dataset,
      filters: props.filters === undefined ? {} : props.filters
    }, auth);
    return data;
  }, {
    onSuccess: (data) => {      
      setData(data);
    }
  });  

  const fuseOptions = {
    shouldSort: true,
    includeScore: true,
    threshold: 0.1,
    location: 0,
    distance: 100,
    maxPatternLength: 32,
    minMatchCharLength: 2,
    keys: ["title"]
  };


  const onSearch = async (value) => {
    if (value !== "") {
      let fuse = new Fuse(dataOrig, fuseOptions);
      let result = fuse.search(value);
      setData(result.map(child => child.item));
    } else {
      setData(dataOrig);
    }
  }

  return (
    <Select
      showSearch
      onSearch={onSearch}
      filterOption={false}
      notFoundContent={loading ? <Spin size="small" /> : null}
      mode={props.multiple ? 'multiple' : null}
      {...props}
    >
      {data.map((item, idx) => {
        if (item.hidden === undefined || (item.hidden && item.hidden === 'N')) {
          return (
            <Select.Option
              key={idx}
              value={item.value}
            >
              {item.title}
            </Select.Option>
          );
        }
      })}
      <Select.OptGroup label="Skryto">
        {data.map((item, idx) => {
          if (item.hidden !== undefined && item.hidden === 'A') {
            return (
              <Select.Option
                key={idx}
                value={item.value}
              >
                {item.title}
              </Select.Option>
            );
          }
        })}
      </Select.OptGroup>
    </Select>
  );
};

export const DatasetSelect1 = (props) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [dataOrig, setDataOrig] = useState([]);
  const auth = useContext(AuthContext);

  const fuseOptions = {
    shouldSort: true,
    includeScore: true,
    threshold: 0.1,
    location: 0,
    distance: 100,
    maxPatternLength: 32,
    minMatchCharLength: 2,
    keys: ["title"]
  };

  const loadData = async () => {
    try {
      let data = await COM.fetchData({
        connector: props.connector,
        dataset: props.dataset,
        filters: props.filters === undefined ? {} : props.filters
      }, auth);
      setData(data);
      setDataOrig(data);
    } catch (err) {
      console.log(err);
    }
  };

  const init = async () => {
    setLoading(true);
    await loadData();
    setLoading(false);
  }

  useEffect(() => {
    init();
  }, []);

  const onSearch = async (value) => {
    setLoading(true);
    if (value !== "") {
      let fuse = new Fuse(dataOrig, fuseOptions);
      let result = fuse.search(value);
      setData(result.map(child => child.item));
    } else {
      setData(dataOrig);
    }
    setLoading(false);
  }

  return (
    <Select
      showSearch
      onSearch={onSearch}
      filterOption={false}
      notFoundContent={loading ? <Spin size="small" /> : null}
      mode={props.multiple ? 'multiple' : null}
      {...props}
    >
      {data.map((item, idx) => {
        if (item.hidden === undefined || (item.hidden && item.hidden === 'N')) {
          return (
            <Select.Option
              key={idx}
              value={item.value}
            >
              {item.title}
            </Select.Option>
          );
        }
      })}
      <Select.OptGroup label="Skryto">
        {data.map((item, idx) => {
          if (item.hidden !== undefined && item.hidden === 'A') {
            return (
              <Select.Option
                key={idx}
                value={item.value}
              >
                {item.title}
              </Select.Option>
            );
          }
        })}
      </Select.OptGroup>
    </Select>
  );
};

export const DatasetSelect = (props) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [dataOrig, setDataOrig] = useState([]);
  const auth = useContext(AuthContext);

  const fuseOptions = {
    shouldSort: true,
    includeScore: true,
    threshold: 0.15,
    location: 0,
    distance: 100,
    maxPatternLength: 32,
    minMatchCharLength: 2,
    keys: ["title"]
  };

  const loadData = async () => {
    try {      
      let data = await COM.fetchData({
        connector: props.connector,
        dataset: props.dataset,
        filters: props.filters === undefined ? {} : props.filters
      }, auth, false);
      setData(data);
      setDataOrig(data);
    } catch (err) {
      console.log(err);
    }
  };

  const init = async () => {
    setLoading(true);
    await loadData();
    setLoading(false);
  }

  useEffect(() => {
    init();
  }, props.invalidateEffect ? props.invalidateEffect : []);

  const onSearch = async (value) => {
    setLoading(true);
    if (value !== "") {
      let fuse = new Fuse(dataOrig, fuseOptions);
      let result = fuse.search(value);      
      setData(result.map(child => child.item));
    } else {
      setData(dataOrig);
    }
    setLoading(false);
  }

  return (
    <Select
      showSearch
      onSearch={onSearch}
      filterOption={false}
      notFoundContent={loading ? <Spin size="small" /> : null}
      mode={props.multiple ? 'multiple' : null}
      {...props}
    >
      {data.map((item, idx) => {
          return (
            <Select.Option
              key={idx}
              value={item.value}
            >
              {item.title}
            </Select.Option>
          );
      })}
    </Select>
  );
};